import { FeatureFlagName } from "@simplyk/common";

import { FeatureFlagTreatmentOutput } from "@/types/trpc";

export const getDonationFormFeatureFlagTreatment = (
  featureFlagTreatments: FeatureFlagTreatmentOutput[] | null | undefined,
  treatment: FeatureFlagName
): boolean => {
  return Boolean(
    featureFlagTreatments?.find((featureFlagTreatment) => featureFlagTreatment.name === treatment)?.treatment
  );
};
